module.exports = __webpack_public_path__ + "grootstatic/media/indian-oil.ea04f028.svg";